import React, { useEffect, useState } from 'react';
import styles from './RangeAnalysisTab_ace.module.css';
import { useRangeAnalysisVehicleData } from './Context';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';

const SingleChargePerformance = () => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData, setGlobalData } = useRangeAnalysisVehicleData()

  const [kpiData, setKpiData] = useState({
    "200Plus": null,
    "200To150": null,
    "150To100": null,
    "100To50": null,
    "AvgKmDriven": null,
  })


  const performanceData = [
    { key: "200Plus", range: '200+ Kms', unit: 'Vehicles', color: 'primary' },
    { key: "200To150", range: '200 - 150 Kms', unit: 'Vehicles', color: 'success' },
    { key: "150To100", range: '150 - 100 Kms', unit: 'Vehicles', color: 'warning' },
    { key: "100To50", range: '100 - 50 Kms', unit: 'Vehicles', color: 'danger' },
    { key: "AvgKmDriven", range: 'Avg. Km Driven', unit: '', color: 'info' }
  ];

  useEffect(() => {

    fetchData({ url: API_URL_MAIN + `ace_range_analysis/single_charge_performance_range`, body: { filterdata: { ...GlobalData } } },
      (data) => {
        setKpiData(prev => ({
          ...prev,
          "200Plus": data?.bucketCounts?.["200+"],
          "200To150": data?.bucketCounts?.["200-150"],
          "150To100": data?.bucketCounts?.["150-100"],
          "100To50": data?.bucketCounts?.["100-50"],
          "AvgKmDriven": data?.Avg_km_Driven,
        }))
      }
    )
  }, [GlobalData])



  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className={`card-title ${styles.cardTitle}`}>Single Charge Performance on Basis of Range</h5>
        </div>

        <div className="row g-3">
          {performanceData?.map((item, index) => (
            <div key={index} className="col-md-2 col-sm-6 ">
              <div className={`card text-center ${styles.performanceCard}`}>
                <div className="card-body py-3 d-flex flex-column justify-content-between">
                  <h6 className={`card-title ${styles.performanceCardTitle}`}>{item.range}</h6>
                  <p className="card-text small text-muted mb-0">{kpiData?.[item.key] !== null ? kpiData?.[item.key] + " " + item.unit : "--"} </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SingleChargePerformance;